<template>
	<div>
		<div v-for="(feeObj, feeObj_i) in fees" :key="feeObj_i" class="row mb-2">
			<div class="col-4">
				<div class="body-strong text-grey-900 text-start text-nowrap" :class="{ 'font-small': isWiypActive && isLocaleNL }">
					{{ packCode === 'HS' ? content[`planner_resumeFee_packageFees_${packCode}`] : content[`planner_resumeFee_${feeObj.name}`] }}
				</div>
			</div>
			<div class="col-8">
				<div class="body-strong text-grey-900 text-end">
					<span v-if="packCode === 'HS'" class="me-1">+</span>
					<span>{{
						displayPrice(parseInt(feeObj.value * 100), locale, 1)
					}}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import displayPrice from "@/displayPrice/displayPrice";


export default {

	name: "Fees",
	components: {},
	computed: {
		...mapState(["content", 'isWiypActive', 'packCode']),
		...mapGetters(["fees", "locale", "isLocaleNL"]),
	},
	methods: {
		displayPrice,
	},
};
</script>

<style scoped>
.font-small {
	font-size: 13px;
}
</style>